// extracted by mini-css-extract-plugin
module.exports = {"menu":"nav_menu__9rtB5","menu__item":"nav_menu__item__lfoX_","menu__item--active":"nav_menu__item--active__X3z_a"};